import styled from "@emotion/styled";

//-------------------------------
// General

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1366px;
`;

export const LightSkies = styled.div`
  position: relative;
  z-index; 25;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background-image: linear-gradient(180deg, #A9DCFF 0%, #C6E7FE 86%, #E2F2FD 100%);
`;

export const LightSkiesBackdrop = styled.div`
  position: fixed;
  z-index: 15;
  background-image: linear-gradient(
    180deg,
    #a9dcff 0%,
    #c6e7fe 86%,
    #e2f2fd 100%
  );
`;

export const Earth = styled.div`
  position: relative;
  z-index; 50;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const DarkSpace = styled.div`
  position: relative;
  z-index; -25;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background-image: linear-gradient(
  //   180deg,
  //   #626262 0%,
  //   #263237 29%,
  //   #202020 100%
  // );
`;

export const BackgroundSkies = styled.div`
  background-image: linear-gradient(
    180deg,
    #a9dcff 0%,
    #e2f2fd 15%,
    #f9f9f9 46%,
    #263237 84%,
    #202020 100%
  );
`;

export const VerticalSpacing = styled.div`
  width: 100%;
  height: 30vh;
`;

export const BoxRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
`;

export const BoxRowFlow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const BoxColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

//-------------------------------
// Responsive

export const responsive = {
  width: "1366px"
};

//-------------------------------
// Design

// Color Scheme
export const colorScheme = {
  primaryColor: "#3949AB",
  secondaryColor: "#ECEFF1",
  neutralDarkColor: "#202020",
  // neutralLightColor: "#ECEFF1"
  neutralLightColor: "#FFFFFF"
};

//-------------------------------
// Article

export const Article = styled.div``;

export const Heading = styled.div`
  font-size: 1.5em;
`;

export const Paragraph = styled.div`
  font-size: 1em;
`;

//-------------------------------
// Title

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

//-------------------------------
// Story

export const Content = styled.div`
  margin: 0 auto;
  max-width: 480px;
  text-align: center;
  padding: 1em;
`;

//-------------------------------
// Dataviz

export const Wide = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: ${colorScheme.primaryColor};
`;

export const WideEllipseTop = styled.div`
  position: absolute;
  bottom: 0;
  height: 150px;
  width: 160%;
  z-index: 25;
  background-color: ${colorScheme.primaryColor};
  // background-color: #283593;
  border-radius: 50% / 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

export const WideEllipseBottom = styled.div`
  position: relative;
  top: 0;
  height: 150px;
  width: 160%;
  background-color: ${colorScheme.primaryColor};
  border-radius: 50% / 100%;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
`;

export const DatavizContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 6vw;
  margin: 0 auto;
  max-width: 1480px;
  // background-color: ${colorScheme.primaryColor};
  color: ${colorScheme.neutralLightColor};
  @media (max-width: ${responsive.width}) {
    flex-direction: column;
    // margin: 0;
    width: 100%;
    // padding: 0 48px;
    justify-content: center;
    align-items: center;
  }
`;

export const Sidebar = styled.div`
  flex-basis: 30%;
  display: flex;
  flex-direction: column;
  padding: 12px 48px;
  width: 100%;
  @media (max-width: ${responsive.width}) {
    max-width: 640px;
    order: 2;
    z-index: 15;
    pointer-events: none;
  }
`;

export const StickyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  flex-basis: 70%;
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  @media (max-width: ${responsive.width}) {
    order: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
  }
`;

export const PlotArea = styled.div`
  position: relative;
  margin: auto 36px auto 0;
  // padding-right: 24px;
  width: 100%;
`;

export const SectionContainer = styled.div`
  display: flex;
  margin: 490px 0;
  @media (max-width: ${responsive.width}) {
    padding: 24px 24px 28px 24px;
    background-color: ${
      colorScheme.primaryColor
    }BF; // BF is 75% opacity for hex
    // border-style: solid;
    // border-width: 1px;
    // border-color: ${colorScheme.neutralLightColor};
    border-radius: 4px;
    pointer-events: none;
  }
`;

//-------------------------------
// ButtonStyle

export const ButtonHover = styled.div`
  border: 1px solid ${colorScheme.neutralLightColor};
  border-radius: 4px;
  margin: 0.4em 0.4em 0 0;
  padding: 3px 8px;
  font-family: "Lato", serif;
  cursor: default;

  &:hover {
    background-color: ${colorScheme.neutralLightColor};
    border: 1px solid ${colorScheme.neutralLightColor};
    color: ${colorScheme.primaryColor};
  }

  &:active {
    background-color: ${colorScheme.neutralLightColor};
    border: 1px solid ${colorScheme.neutralLightColor};
    color: ${colorScheme.primaryColor};
  }
`;

export const ButtonHovered = styled.div`
  outline: 2px white;
`;

//-------------------------------
// Label

export const Label = styled.div`
  margin: 0 0.5em 0 0;
  padding: 0.5em;
  font-family: "Lato", serif;
`;

//-------------------------------
// Country Dots

export const countryRegionColor = region => {
  switch (region) {
    case "Africa":
      return "#F44336";
    case "Americas":
      // return "#36474F";
      return "#84979F";
    case "Asia":
      return "#FFC105";
    case "Europe":
      return "#64B5F6";
    case "Oceania":
      return "#8BC34A";
    default:
      return "#283593";
  }
};

// //-------------------------------
// // Circle

export const CircleStyle = styled.circle`
  stroke-width: 2;
  stroke-dasharray: 4, 6;
  stroke: #d8d8d8;
  fill: none;
`;

// //-------------------------------
// // Pictures

export const EntryPicture = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  // justify-content: center;
  // align-content: center;
  // max-width: ${responsive.width};
  // margin: 0 auto;
`;

export const ExitPicture = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;
